import React from 'react';
import { Grid } from '@mui/material';
import { DateRangePicker, SingleInputDateRangeField } from '@mui/x-date-pickers-pro';
import LocalizedDatePicker from '../../custom-widgets/LocalizedDatePicker';
import moment from 'moment-timezone';

const ToolbarDateRangePicker = ({ label, views, startDate, endDate, handleDateRangeChange, sx, minDate, maxDate, disabled, size }) => (
    <Grid item sx={{ marginRight: '16px' }}>
        <LocalizedDatePicker
            Picker={DateRangePicker}
            label={label || 'Date Range'}
            views={views || ['year', 'month', 'day']}
            value={[startDate, endDate]}
            slots={{ field: SingleInputDateRangeField }}
            onChange={([startDateArg, endDateArg]) => {
                const start = startDateArg || startDate || moment().startOf('month');
                const end = endDateArg || endDate || moment().endOf('month');
                handleDateRangeChange(start.clone().startOf('day'), end.clone().endOf('day'));
            }}
            slotProps={{ textField: { size } }}
            disabled={disabled}
            minDate={minDate}
            maxDate={maxDate}
            sx={sx}
        />
    </Grid>
);

export default ToolbarDateRangePicker;
